module.exports = __webpack_public_path__ + "static/media/Background Info.16a9097e.txt";